export default __webpack_public_path__ + "static/media/myinfo.49fa06d9.svg";